import React from 'react';
import { useSynapse } from 'app/lib/synaptik';
import { Icon, styled } from '@goodrx/matisse';

const UnreadIcon = styled.div`
  position: absolute;
  top: -1px;
  right: -3px;
  height: 10px;
  width: 10px;
  background: ${(p) => p.theme.colors.red};
  z-index: 1;
  border-radius: 50%;
`;

const Contain = styled.div`
  position: relative;
`;

const MessageIcon = ({ className, showUnreadIcon = true }: any) => {
  const [hasUnreadMessages] = useSynapse(({ chat }) => [chat.hasUnreadMessages()]);

  return (
    <Contain>
      <Icon className={className} name="forum" />
      {hasUnreadMessages && showUnreadIcon && <UnreadIcon />}
    </Contain>
  );
};

export default MessageIcon;
